function dropdownFilterHide() {
	$(".filter__responsive").hide();
}
